import { UNSAFE_openUpgradeModal as openUpgradeModal } from '@/hooks/useUpgradeModal'
import { checkModuleAccess } from '@/modules'
import { subscriptionLimits } from '@/modules/base/util/constants'

/**
 * upgrade modal handling for pricing model based on functional limits (e.g. no offers included in user's current plan)
 *
 * reads in a subscription module or subscription limit
 * opens the upgrade modal with the subscription limit as information
 *
 * @param {string} subscriptionModule - a string constant that specifies a subscription module
 * @param {function||null} onCloseUpgradeModal - optional function that should be executed when users close the upgrade modal
 * @returns false
 */
const showUpgradeModalIfNotInPlan = (subscriptionModule, onCloseUpgradeModal = null) => {
  const notInPlanSuffix = '_NOTINPLAN'
  subscriptionModule = subscriptionModule.toUpperCase()
  const limit = `${subscriptionModule}${notInPlanSuffix}`
  const notInPlan = !checkModuleAccess(subscriptionModule)
  if (notInPlan) {
    openUpgradeModal(
      {
        limitReached: subscriptionLimits[limit] !== undefined ? subscriptionLimits[limit] : subscriptionLimits.DEFAULT_NOTINPLAN,
        subscriptionChange: true,
        subscriptionType: 'main',
        onClose: onCloseUpgradeModal,
      },
    )
  }

  return notInPlan
}

export default showUpgradeModalIfNotInPlan
